enum ELicenseType {
  NEW = 'new',
  RENEW = 'renew',
}

export default ELicenseType;
